import React, { useEffect } from "react";

export default function SlideOver({ open, onClose, title, children, width = 340 }) {
	useEffect(() => {
		if (!open) return;
		const onKey = (e) => {
			if (e.key === "Escape") onClose?.();
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [open, onClose]);

	if (!open) return null;

	return (
		<>
			<div className="editor-slideover-backdrop" onClick={onClose} />
			<aside
				className="editor-slideover open"
				style={{ width }}
			>
				<header className="editor-slideover-header">
					<span className="editor-slideover-pill">
						<span className="editor-slideover-pill-dot" />
						{title}
					</span>
					<button
						className="editor-slideover-esc"
						onClick={onClose}
						title="Fermer (Esc)"
					>
						Esc <span className="editor-slideover-esc-x">×</span>
					</button>
				</header>
				<div className="editor-slideover-body">
					{children}
				</div>
			</aside>
		</>
	);
}
